import React from 'react'

var SearchBox = React.createClass({
    getInitialState: function(){
      return {value: ""}
    },
    handleChange: function(e){
      this.setState({value: e.target.value})
      this.props.searchPackage(e.target.value.toLowerCase());
    },
    handleSearchClick: function(){
      this.props.searchPackage(this.state.value.toLowerCase());
    },
    render: function(){
      return(
           <div className="content__col content__col--third">
            <div className="site-search">
              <form action="javascript:void(0)">
                <input type="text" placeholder = "search.." onChange = {this.handleChange} value={this.state.value} name="search" />
                <div className="search-btn">
                  <button onClick = {this.handleSearchClick}><i className="fa fa-search"></i></button>
                </div>
              </form>
            </div>
          </div>
        );
    }
});

export {SearchBox};


/** WEBPACK FOOTER **
 ** ./html/components/SearchBox.jsx
 **/